module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="edit-section">\r\n    <h1>Relation type edit</h1>\r\n    <div id="relationtype-form" class="edit-form"></div>\r\n    <div id="edit-buttons" class="edit-buttons">\r\n        <div class="left-buttons">\r\n            <button type="button" class="btn btn-default" id="cancel-edit">Cancel</button>\r\n            <button type="button" class="btn btn-primary" id="save-relationtype">Save changes</button>\r\n        </div>\r\n        <div class="right-buttons">\r\n            <button type="button" class="btn btn-danger" id="remove-relationtype">Remove</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class="delete-confirmation-modal"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/relationtypes/relationtype.html
// module id = 437
// module chunks = 0